import React from 'react';
import PropTypes from 'prop-types';
import {
    FIELD_STANDARD_CLASS,
    FIELD_ERROR_CLASS,
    CONFIRM_PWD_INVALID_MSG,
} from '../../../helpers/messageText';

class FieldConfirmPassword extends React.Component {
    constructor() {
        super();
        this.state = {
            showConfirmPassword: false,
        };
    }

    viewConfirmPassword() {
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
    }

    renderClass(valid) {
        if (valid) {
            return FIELD_STANDARD_CLASS;
        }
        return FIELD_ERROR_CLASS;
    }

    renderMessage(valid) {
        if (!valid) {
            return <div className="small form-control-feedback">{CONFIRM_PWD_INVALID_MSG}</div>;
        }
    }

    render() {
        return (
            <div className={this.renderClass(this.props.fieldState)}>
                <label className="col-sm-2 form-control-label">Confirm Password</label>
                <div className="col-sm-10">
                    <div className="input-group">
                        <input
                            ref={input => (this.confirmPassword = input)}
                            type={this.state.showConfirmPassword ? 'text' : 'password'}
                            name="confirmPassword"
                            onChange={e => this.props.handleChange(e)}
                            className="form-control"
                            placeholder=""
                        />
                        <span
                            className="input-group-addon"
                            onClick={() => {
                                this.viewConfirmPassword();
                            }}
                        >
                            <i className="fa fa-eye cursor-pointer" aria-hidden="true" />
                        </span>
                    </div>
                    {this.renderMessage(this.props.fieldState)}
                </div>
            </div>
        );
    }
}

FieldConfirmPassword.propTypes = {
    handleChange: PropTypes.func.isRequired,
    fieldState: PropTypes.bool.isRequired,
    defaultValue: PropTypes.string,
};

export default FieldConfirmPassword;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/ConfirmPassword.js